import React, {useState, useEffect} from 'react';

function ClientViewPageFooter({setVisible, canUpdate}) {
    const [seconds, setSeconds] = useState(0);
    const [memory, setMemory] = useState(0);

    const handleOpenModal = () => {
        if (canUpdate) {
            setVisible(true)
        }
    }

    useEffect(() => {
        const fetchUptime = async () => {
            if (window.pywebview && window.pywebview.api) {
                const up = await window.pywebview.api.get_uptime();
                setSeconds(up);

                const mem = await window.pywebview.api.get_memory_usage();
                setMemory(mem);
            }
        };

        const interval = setInterval(fetchUptime, 1000);
        return () => clearInterval(interval);
    }, []);

    const formatUptime = (s) => {
        const h = Math.floor(s / 3600).toString().padStart(2, '0');
        const m = Math.floor((s % 3600) / 60).toString().padStart(2, '0');
        const sec = (s % 60).toString().padStart(2, '0');
        return `${h}:${m}:${sec}`;
    };

    const handleMinimize = () => {
        if (window.pywebview && window.pywebview.api && window.pywebview.api.minimize_window) {
            window.pywebview.api.minimize_window();
        }
    };

    return (
        <footer className="px-8 py-5 border-t border-slate-300 dark:border-[#233648] bg-white/50 dark:bg-[#16222d]/50 backdrop-blur-sm flex items-center justify-between gap-6 shrink-0">
            <div className="flex items-center gap-4">
                <button onClick={handleOpenModal} className={`${canUpdate === true ? "cursor-pointer hover:text-white hover:bg-slate-500/10 hover:border-slate-400" : "cursor-not-allowed"} flex items-center justify-center size-12 rounded-xl border border-slate-300 dark:border-[#324d67] text-slate-500 transition-all relative`}>
                    <span className="material-symbols-outlined text-2xl">download</span>

                    {canUpdate === true &&
                        <span className="absolute top-2 right-2 size-1.5 bg-acc-red rounded-full animate-pulse"></span>
                    }
                </button>
            </div>

            <div className="flex-1 flex justify-center">
                <button onClick={handleMinimize} className="w-full max-w-md bg-primary hover:bg-primary/90 text-white text-base font-bold h-12 px-8 rounded-xl flex items-center justify-center gap-3 transition-all shadow-xl shadow-primary/30 active:scale-[0.98]">
                    <span className="material-symbols-outlined">expand_more</span>
                    <span>Minimize Client to System Tray</span>
                </button>
            </div>
            
            <div className="flex items-center gap-4 text-slate-500">
                <div className="text-right">
                    <p className="text-[10px] font-bold uppercase tracking-widest">Uptime</p>
                    <p className="text-sm font-mono text-slate-300">{formatUptime(seconds)}</p>
                </div>

                <div className="h-8 w-px bg-slate-300 dark:bg-[#233648]"></div>

                <div className="text-right">
                    <p className="text-[10px] font-bold uppercase tracking-widest">Ram Usage</p>
                    <p className={`${memory < 300 ? "text-emerald-500" : memory < 500 ? "text-acc-yellow" : "text-acc-red"} text-sm font-mono`}>{memory}MB</p>
                </div>
            </div>
        </footer>
    );
}


export default ClientViewPageFooter;